export default {
      id: "viewStream-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#viewStream-usage",
      toString: function () {
        return this.url;
      }
    }